import type { TypedDispatch } from '../Store/store';
import fetch from '../../../js/api/fetch';
import { addError } from '../Store/MetaData/action';
import { updateRootState } from './updateRootState';

const changeProductAmount = (
  dispatch: TypedDispatch,
  cartItemId: string,
  amount: number,
): void => {
  fetch('checkout/changeProductAmountInCart', {
    body: JSON.stringify({ amount: Math.max(1, amount), cartItemId }),
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
    },
    method: 'POST',
  })
    .then(() => updateRootState(dispatch))
    .catch(() => dispatch(addError()));
};

export default changeProductAmount;
